import { render, staticRenderFns } from "./RefInfo.vue?vue&type=template&id=45afe3a0&scoped=true&"
import script from "./RefInfo.vue?vue&type=script&lang=js&"
export * from "./RefInfo.vue?vue&type=script&lang=js&"
import style0 from "./RefInfo.vue?vue&type=style&index=0&id=45afe3a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45afe3a0",
  null
  
)

export default component.exports